import TalleresHomeComponent from '@/components/talleres/TalleresHomeComponent'
import OrdenServicioContentComponent from '@/components/talleres/OrdenServicioContentComponent'



export default [
    {
    path: '/talleres/inicio',
    name: 'talleres-home',
    component: TalleresHomeComponent,
    meta: {
        requiresAuth: true
    }
},{
    path: '/talleres/editar/:id',
    name: 'talleres-editar-home',
    component: OrdenServicioContentComponent,
    meta: {
        requiresAuth: true
    }
},
]
